'use client';

import { useEffect, useState } from 'react';
import { getUserData } from '../actions/user-actions';

const ClerkUserDetails = ({ showName = true }: { showName?: boolean }) => {
  const [userData, setUserData] = useState<{
    primary_email_address?: string;
    full_name?: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchUserData() {
      try {
        const data = await getUserData();
        setUserData(data);
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchUserData();
  }, []);

  if (loading) {
    return <div className="h-10 w-40 animate-pulse rounded bg-muted"></div>;
  }

  if (!userData) {
    return null;
  }

  const { primary_email_address, full_name } = userData;

  const name = (
    <div className="mb-0.5 truncate text-label text-foreground">
      {full_name as string}
    </div>
  );

  const loggedInAs = !showName && (
    <div className="text-caption text-muted-foreground">Logged in as</div>
  );

  return (
    <div className="flex flex-col">
      {showName ? name : loggedInAs}
      <div className="truncate text-caption text-muted-foreground">
        {primary_email_address as string}
      </div>
    </div>
  );
};

export default ClerkUserDetails;
